import React from "react";
import { DEFAULT_PAGE_SIZE } from "constants/configs";
import { FetchDataForPageFunc } from "hooks/usePaginatedData";
import { useToast } from "hooks/useToast";
import { ApplicationSearchFormData, IApplicationSearchItem } from "models/Application.model";
import { SearchApplicationsForPageArgs } from "services/application-search/ApplicationSearchService.type";
import { serviceContainer } from "services/serviceContainer";
import isEmpty from "lodash/isEmpty";

export const useApplicationSearch = (args: ApplicationSearchFormData) => {
  const { toastError } = useToast();

  const runFetchPaginatedApplications = React.useCallback(
    async (thunkArgs: SearchApplicationsForPageArgs) => {
      try {
        const data = await serviceContainer.cradle.applicationSearchService.searchApplications(thunkArgs);
        const hasNextPage = data.length === DEFAULT_PAGE_SIZE;
        return { data, hasNextPage };
      } catch (e) {
        toastError(e);
        throw e;
      }
    },
    [toastError]
  );

  const isApplicationsSearchArgsValid = React.useMemo(() => {
    return args.address || (args.applicationNumber && !isEmpty(args.authorities));
  }, [args]);

  const searchApplicationsForPage: FetchDataForPageFunc<IApplicationSearchItem> = React.useCallback(
    (pageIndex) => {
      if (!isApplicationsSearchArgsValid) {
        return Promise.resolve({ data: [], hasNextPage: false });
      }

      return runFetchPaginatedApplications({
        ...args,
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: pageIndex,
      });
    },
    [runFetchPaginatedApplications, args, isApplicationsSearchArgsValid]
  );

  return searchApplicationsForPage;
};
